import styled from 'styled-components';

import { getThemeColorWithError, getThemeColor } from '@utils/styled';

import Typography from '@common/components/Typography';

export const Wrapper = styled.div`
  display: flex;
  align-items: flex-start;
  ${({ theme }) => theme.getFluidSpacing('padding-top', 'scale', 6)};
  ${({ theme }) => theme.getFluidSpacing('padding-bottom', 'scale', 6)};
`;

export const Indicator = styled.div`
  width: 1rem;
  height: 1rem;
  margin-top: 0.2rem;
  border-radius: ${({ theme }) => theme.borderRadiuses.circle};
  background-color: ${getThemeColorWithError(
    'hue.red',
    'hue.green',
    'isStoreOpen',
  )};
`;

export const Caption = styled(Typography).attrs({
  customAs: 'p',
  variant: 'body4',
})`
  margin-bottom: 0;
  color: ${getThemeColor('bluegrey.60')};
`;

export const ColoredCaption = styled(Caption)`
  flex-shrink: 0;
  margin: 0 0.5rem 0 0.3rem;
  color: ${getThemeColorWithError('hue.red', 'hue.green', 'isStoreOpen')};
  font-weight: 500;
`;
